export default __webpack_public_path__ + "static/media/pin.a4ade88f.svg";